export const echartsTooltipClassName = 'echarts-tooltip';
